import React from 'react';
import Translate from 'react-translate-component';

export class GetBankId extends React.Component {

  render () {
    return (<a href="http://support.bankid.com/mobil" className="get-bank-id" target="_blank">
      <Translate content="GET_BANKKID"/>
    </a>);
  }
}

export default GetBankId;



/** WEBPACK FOOTER **
 ** ./src/components/bank-id/get-bank-id.js
 **/